import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  Ch_signMeasRadiologyPrescriptionDocumentInput,
  useChSignRadiologyPrescriptionMutation as useChSignRadiologyPrescriptionMutationType,
} from "@/modules/patients/detail/meas-radiology-prescription/ch/services/__generated__/useChSignRadiologyPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChSignRadiologyPrescriptionMutation($input: Ch_signMeasRadiologyPrescriptionDocumentInput!) {
    ch_signMeasRadiologyPrescriptionDocument(input: $input) {
      ch_MeasRadiologyPrescription {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...chMeasRadiologyPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChSignRadiologyPrescriptionMutationType>, "variables"> & {
  id: Ch_signMeasRadiologyPrescriptionDocumentInput["id"]
}

const useChSignRadiologyPrescriptionMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChSignRadiologyPrescriptionMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSignRadiologyPrescriptionMutation }
